import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Linkedin, Twitter, BookOpen, Award } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InstructorsPage = () => {
  const [instructors, setInstructors] = useState([]);

  useEffect(() => {
    fetchInstructors();
  }, []);

  const fetchInstructors = async () => {
    try {
      const response = await axios.get(`${API}/instructors`);
      setInstructors(response.data);
    } catch (error) {
      console.error('Failed to fetch instructors:', error);
    }
  };

  const scrollToEnroll = () => {
    window.location.href = '/pricing';
  };

  return (
    <div className="page instructors-page">
      <Header onEnrollClick={scrollToEnroll} />
      
      <main className="page-content">
        {/* Hero */}
        <section className="page-hero">
          <div className="container">
            <span className="section-tag">Meet Your Mentors</span>
            <h1 className="page-title">World-Class Instructors</h1>
            <p className="page-subtitle">
              Learn from industry leaders who have shaped the AI landscape
            </p>
          </div>
        </section>

        {/* Instructors Grid */}
        <section className="instructors-section">
          <div className="container">
            <div className="instructors-grid">
              {instructors.map((instructor) => (
                <div key={instructor.id} className="instructor-card">
                  <div className="instructor-image-wrapper">
                    <img 
                      src={instructor.image} 
                      alt={instructor.name}
                      className="instructor-image"
                    />
                  </div>
                  <div className="instructor-info">
                    <h3 className="instructor-name">{instructor.name}</h3>
                    <p className="instructor-title">{instructor.title}</p>
                    <p className="instructor-bio">{instructor.bio}</p>
                    
                    <div className="instructor-expertise">
                      {instructor.expertise?.map((skill, idx) => (
                        <span key={idx} className="expertise-tag">{skill}</span>
                      ))}
                    </div>

                    <div className="instructor-social">
                      <a href={instructor.linkedin} className="social-btn" aria-label="LinkedIn">
                        <Linkedin size={18} />
                      </a>
                      <a href={instructor.twitter} className="social-btn" aria-label="Twitter">
                        <Twitter size={18} />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="instructor-stats">
          <div className="container">
            <div className="stats-grid">
              <div className="stat-card">
                <BookOpen className="stat-icon" />
                <span className="stat-number">50+</span>
                <span className="stat-text">Years Combined Experience</span>
              </div>
              <div className="stat-card">
                <Award className="stat-icon" />
                <span className="stat-number">200+</span>
                <span className="stat-text">Research Papers Published</span>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="instructors-cta">
          <div className="container">
            <div className="cta-card">
              <h2>Learn Directly From Industry Experts</h2>
              <p>Get personalized feedback and guidance throughout your journey</p>
              <Link to="/pricing">
                <Button className="btn-primary">
                  Start Learning Today
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default InstructorsPage;
